import { defineMessages } from 'react-intl';

export default defineMessages({
    PolicyNumber: {
        id: 'cep.components.sgPolicySummaryTile.PolicyNumber',
        defaultMessage: 'Policy number'
    },
    StartDate: {
        id: 'cep.components.sgPolicySummaryTile.StartDate',
        defaultMessage: 'Start date'
    },
    MyDocuments: {
        id: 'cep.components.sgPolicySummaryTile.MyDocuments',
        defaultMessage: 'My documents'
    },
    AmendPolicy: {
        id: 'cep.components.sgPolicySummaryTile.AmendPolicy',
        defaultMessage: 'Amend policy'
    },
    Payments: {
        id: 'cep.components.sgPolicySummaryTile.Payments',
        defaultMessage: 'Payments'
    }
});
